import React, { useContext, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { CButton } from '@app/components/Common';
import { View } from '@/styles/reactnative';
import { useTradeModalStore } from '../../../../../../../hooks/trade/modalStore';
import { ThemeContext } from '@/theme/ThemeProvider';
import { useDemoTradingStore } from '@app/hooks/trade/demoTradingStore';
import { DemoWalletDepositModal } from '@app/components/Trade/DemoWalletDepositModal';

const AccountTransfer = ({ bgColor, color }) => {
  const { t } = useTranslation();
  const { theme } = useContext(ThemeContext);
  const { isDemoMode } = useDemoTradingStore();
  const [demoDepositModalOpen, setDemoDepositModalOpen] = useState(false);

  const { data: modalStore, mutate: muatateModalStore } = useTradeModalStore();

  const openModal = () => {
    if (isDemoMode) {
      // 모의거래 모드: 모의지갑입금 모달 오픈
      setDemoDepositModalOpen(true);
    } else {
      // 실거래 모드: 기존 지갑전송 모달 오픈
      muatateModalStore({ ...modalStore, transferModal: true });
    }
  };

  return (
    <>
      <CButton
        title={
          isDemoMode ? t('demo.walletDeposit') || '모의지갑입금' : t('transfer')
        }
        onClick={() => {
          openModal();
        }}
        style={{
          border: 'none',
          background: '#2A2C2E',
          color: '#E9E9ED',
          height: '34px',
          width: '100%',
          borderRadius: 6,
          boxSizing: 'border-box',
          flex: 1,
          fontFamily: 'NanumSquareRound',
          fontWeight: 700,
          fontSize: 12,
          letterSpacing: -0.36,
        }}
      />

      {/* 모의거래 지갑 입금 모달 */}
      {isDemoMode && (
        <DemoWalletDepositModal
          open={demoDepositModalOpen}
          setOpen={setDemoDepositModalOpen}
          onSuccess={() => {
            // 입금 성공 시 추가 작업
          }}
        />
      )}
    </>
  );
};

export default AccountTransfer;
